<div class="card card-custom h-100">
    <div class="card-header align-items-center border-0">
        <h3 class="card-title align-items-start flex-column">
                <span class="font-weight-bolder text-dark">
                    Revenue Data
                </span>
        </h3>
        <!-- <div class="card-toolbar">
            <button (click)="memberActivityTable.reload()" class="btn btn-primary"><i
                class="fa fa-sync"></i> Refresh</button>
        </div> -->
    </div>
    <div class="card-body" [perfectScrollbar]>
        <div class="scroller chart" [perfectScrollbar]>
            <div class="primeng-datatable-container revenue-datas-table" *ngIf="!loading"
                 [busyIf]="primengTableHelper.isLoading">
                <p-table #RevenueDatasTable [value]="revenueDatas"
                         rows="{{primengTableHelper.defaultRecordsCountPerPage}}" [paginator]="false"
                         [lazy]="false" [responsive]="primengTableHelper.isResponsive">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Currency</th>
                            <th>Gateway Charge</th>
                            <th>Cost</th>
                            <th>Reseller Charge</th>
                            <th>Net Charge</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-revenueDatas="$implicit">
                        <tr>
                            <td>
                                <span class="p-column-title">Currency</span>
                                {{revenueDatas.CurrencyCode}}
                            </td>
                            <td>
                                <span class="p-column-title">Gateway Charge</span>
                                {{revenueDatas.GatewayCharge}}
                            </td>
                            <td>
                                <span class="p-column-title">Cost</span>
                                {{revenueDatas.Cost}}
                            </td>
                            <td>
                                <span class="p-column-title">Reseller Charge</span>
                                {{revenueDatas.ResellerCharge}}
                            </td>
                            <td>
                                <span class="p-column-title">Net Charge</span>
                                {{revenueDatas.NetCharge}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="primeng-no-data" *ngIf="revenueDatas.length == 0">
                    {{'NoData' | localize}}
                </div>
            </div>
        </div>
    </div>
</div>
